// consentMode.js
export function updateGoogleConsent(consent) {
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: consent.marketing ? "granted" : "denied",
        analytics_storage: consent.analytics ? "granted" : "denied",
        ad_user_data: consent.sale_of_data ? "granted" : "denied",
        ad_personalization: consent.marketing ? "granted" : "denied",
      });
    } else {
      console.warn("gtag not loaded yet");
    }
  }